interface Config {
	minFontSize?: number;
	maxFontSize?: number;
}

export function fitText(node: HTMLElement, options: Config = {}) {
	let { minFontSize = 24, maxFontSize = 80 } = options;
	let parentWidth = 0;

	function resize() {
		const parent = node.parentElement;
		if (!parent || parentWidth === parent.clientWidth) return;

		parentWidth = parent.clientWidth;

		let low = minFontSize + 1;
		let high = maxFontSize;
		let fontSize = high;

		node.style.fontSize = `${fontSize}px`;

		while (low <= high) {
			fontSize = Math.floor((low + high) * 0.5);
			node.style.fontSize = `${fontSize}px`;

			if (node.scrollHeight > parent.clientHeight) {
				high = fontSize - 1;
			} else {
				low = fontSize + 1;
			}
		}
		node.style.fontSize = `${high}px`;
	}

	resize();

	window.addEventListener('resize', resize);

	return {
		update(newOptions: Config) {
			minFontSize = newOptions.minFontSize ?? minFontSize;
			maxFontSize = newOptions.maxFontSize ?? maxFontSize;
			resize();
		},
		destroy() {
			window.removeEventListener('resize', resize);
		}
	};
}
